export default __webpack_public_path__ + "static/Mvp-00d71974c1e384ecb75ec91b4cbca912.png";